export const ABSOLUTE_PATH = window.location.origin;

// Change this variable to switch API endpoints.
export const API_BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL || `${ABSOLUTE_PATH}/api`;
